

export default class WhoScroll {

    constructor(){

        var scrollBlock__top  = window.pageYOffset || document.documentElement.scrollTop  ;
        var scrollBlock__left = window.pageXOffset || document.documentElement.scrollLeft ;

        window.addEventListener( 'scroll', (e) => {


            if( true === window.whodunit.theme.scrollBlock ){
                window.scrollTo(scrollBlock__left, scrollBlock__top);
                return;
            }

            scrollBlock__top  = window.pageYOffset || document.documentElement.scrollTop  ;
            scrollBlock__left = window.pageXOffset || document.documentElement.scrollLeft ;

        });
    }

}